import { gql } from "@apollo/client";
import { EmailProcessingStatsType, MailboxType} from "./schemeTypes";

export const MAILBOX_SESSION_UPDATED = gql`
    subscription mailboxSessionUpdated {
        mailboxSessionUpdated ${MailboxType}
    }
`;

export const MAILBOXES_STATS_SUBSCRIPTION = gql`
    subscription mailboxesStatSubscription($userId: ID!) {
        mailboxesStatSubscription(userId: $userId) ${EmailProcessingStatsType}
    }
`;

export const ALL_MAILBOX_PROCESSING = gql`
    subscription allMailboxProcessingPercentage {
        allMailboxProcessingPercentage {
            percent
        }
    }
`;